import { Drawer, LoadingOverlay } from "@mantine/core";
import { useAccount, useContact } from "../../hooks/QueryHooks";
import useWorkspaceStore from "../../store/workspace/workspaceStore";
import useEntityDrawerStore from "../../store/drawer/entityDrawerStore";
import EntityDetails from "./EntityDetails";

const EntityDrawer = () => {
  const { isOpen, entity, closeDrawer } = useEntityDrawerStore();
  const workspace = useWorkspaceStore((state) => state.workspace);

  const account = useAccount({
    workspaceId: workspace?.id,
    accountId: entity?.id || "",
    enabled: !!workspace?.id && !!entity?.id && entity?.type === "accounts",
  });

  const contact = useContact({
    workspaceId: workspace?.id,
    contactId: entity?.id || "",
    enabled: !!workspace?.id && !!entity?.id && entity?.type === "users",
  });

  const handleClose = () => {
    closeDrawer();
  };

  const entityData = entity?.type === "accounts" ? account?.data : contact?.data;
  const isLoading = entity?.type === "accounts" ? account.isLoading : contact.isLoading;

  return (
    <Drawer
      opened={isOpen}
      onClose={handleClose}
      classNames={{
        title: "text-[20px] italic font-semibold",
      }}
      position="right"
      size="750px"
      withCloseButton
      withOverlay
      title={entity?.type === "accounts" ? 'Account Details' : 'User Details'}
    >
      <LoadingOverlay
        loaderProps={{ size: "md" }}
        c="main.5"
        visible={isLoading}
        overlayProps={{ blur: 2 }}
      />
      {(entityData && entity) ? (
        <EntityDetails
          closeDrawer={handleClose}
          workspaceId={workspace?.id}
          entityRelation={entity.type}
          entity={entityData}
        />
      ) : null}
    </Drawer>
  );
};

export default EntityDrawer;
